import { useEffect, useState } from "react";
import { Box, Center, HStack, VStack, useMediaQuery } from "native-base";
import { COLORS } from "../../../utils/colors";
import ContainerCards from "../../../components/cards";
import PeopleDetails from "../../../containers/peopleDetails";
import CustomButton from "../../../components/button";
import NoDataFound from "../../../components/noDataFound";
import { MOBILE_VIEW_WIDTH } from "../../../utils/screens";
import { hasPermission } from "../../../utils/permission";

const PeopleDetailsListing = ({
  eventsDetail,
  getEventDetails,
  setUploadActiveButton = () => {},
  openModal = () => {},
  handleUploadDoc = () => {},
  selected,
  filteredAttendees,
}) => {
  const [people, setPeople] = useState([]);
  const [visibleItems, setVisibleItems] = useState(10);
  const [MobileWindow] = useMediaQuery({
    maxWidth: MOBILE_VIEW_WIDTH,
  });

  useEffect(() => {
    if (filteredAttendees) {
      setPeople(filteredAttendees);
      setVisibleItems(10); // Reset visible items when filtered list changes
    } else if (eventsDetail && eventsDetail.employee) {
      setPeople(eventsDetail.employee);
    }
  }, [eventsDetail, filteredAttendees]);

  const showMore = () => {
    setVisibleItems((prevVisibleItems) => prevVisibleItems + 10);
  };

  return (
    <VStack width={"100%"}>
      <div
        style={{
          display: MobileWindow ? "flex" : "grid",
          gridTemplateColumns:
            people.length > 0 && `repeat(auto-fill, minmax(${30}%, 1fr))`,

          gap: "20px",
          marginRight: !MobileWindow && "20px",
          flexWrap: "wrap",
        }}
      >
        {people.length > 0 ? (
          people?.slice(0, visibleItems).map((item) => {
            let noOfDocs = 0;
            if (item.boarding_pass_path && item.boarding_pass_path.length) {
              noOfDocs = item.boarding_pass_path.length;
            }
            // Remove this if condition to check if the user is a vendor and need to make the visibility of the attendee card visible to the vendor
            if (
              !hasPermission("VENDOR") ||
              (hasPermission("VENDOR") && selected)
              // ||
              // (hasPermission("VENDOR") && !selected && item.board_member)
            )
              return (
                <ContainerCards
                  border="1px solid #D0D5DD"
                  boxShadow="0px 1px 2px 0px rgba(16, 24, 40, 0.05)"
                  background={COLORS.PEOPLE_CARD_BG_COLOR}
                  width="100%"
                  height="auto"
                  minH="75px"
                  maxW="100%"
                  mr={4}
                >
                  <PeopleDetails
                    name={item.display_name}
                    email={item.email}
                    setUploadActiveButton={setUploadActiveButton}
                    openModal={openModal}
                    people={item}
                    total={noOfDocs}
                    handleUploadDoc={handleUploadDoc}
                    status={eventsDetail.status}
                    selected={selected}
                    eventsDetail={eventsDetail}
                    getEventDetails={getEventDetails}
                  />
                </ContainerCards>
              );
            // else
            //   return <Box mb={"100px"} m={"auto"} top={25}>
            //     <NoDataFound dataName="attendee" image={false} />
            //   </Box>;
          })
        ) : (
          <Box mb={"100px"} m={"auto"} top={25}>
            <NoDataFound dataName="attendee" image={false} />
          </Box>
        )}
      </div>
      <Center flex={1} pb={4} px={4} pt={3}>
     {/* Remove from this condition to check if the user is a vendor and need to make the visibility of the attendee card visible to the vendor */}
        {!hasPermission("VENDOR")
          ? people &&
            visibleItems < people.length && (
              <CustomButton
                isOutline
                text="View More"
                textColor={COLORS.BLACK_COLOR}
                bgColor={COLORS.BLACK_COLOR}
                borderRadius="50px"
                width="fit-content"
                onPress={showMore}
              />
            )
          : hasPermission("VENDOR") &&
            selected &&     // Remove till thiscondition to check if the user is a vendor and need to make the visibility of the attendee card visible to the vendor
            people &&
            visibleItems < people.length && (
              <CustomButton
                isOutline
                text="View More"
                textColor={COLORS.BLACK_COLOR}
                bgColor={COLORS.BLACK_COLOR}
                borderRadius="50px"
                width="fit-content"
                onPress={showMore}
              />
            )}
      </Center>
    </VStack>
  );
};

export default PeopleDetailsListing;
